import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import {
  PROSPECT_STAGE_CPS,
  PROSPECT_STAGE_FIN,
  PROSPECT_STAGE_FND,
  PROSPECT_STAGE_INS,
  PROSPECT_STAGE_LOG,
  PROSPECT_STAGE_SB,
  PROSPECT_STAGE_TL,
  PROSPECT_STAGE_TR,
  PROSPECT_STAGE_TS,
  PROSPECT_STAGE_PDM,
  PROSPECT_STAGE_UNITED,
} from '../constants/supportTypes'
import {
  CPS,
  FINANCE,
  FUNDING,
  INSURANCE,
  LOGISTICS,
  PLANET_DIGITAL_MEDIA,
  SMARTBOARD,
  TRAILER_LEASING,
  TRUCK_RENTAL,
  TRUCK_SALES,
  UNITED,
} from '../constants/divisions'

const useGetProspectStageByDivision = () => {
  const { divisionId } = useSelector((state) => ({
    divisionId: state.auth.user.division_id,
  }))
  const [options, setOptions] = useState([])

  useEffect(() => {
    const loadData = async () => {
      let type = null

      if (divisionId === CPS) type = PROSPECT_STAGE_CPS
      else if (divisionId === FINANCE) type = PROSPECT_STAGE_FIN
      else if (divisionId === FUNDING) type = PROSPECT_STAGE_FND
      else if (divisionId === INSURANCE) type = PROSPECT_STAGE_INS
      else if (divisionId === LOGISTICS) type = PROSPECT_STAGE_LOG
      else if (divisionId === SMARTBOARD) type = PROSPECT_STAGE_SB
      else if (divisionId === TRAILER_LEASING) type = PROSPECT_STAGE_TL
      else if (divisionId === TRUCK_RENTAL) type = PROSPECT_STAGE_TR
      else if (divisionId === TRUCK_SALES) type = PROSPECT_STAGE_TS
      else if (divisionId === PLANET_DIGITAL_MEDIA) type = PROSPECT_STAGE_PDM
      else if (divisionId === UNITED) type = PROSPECT_STAGE_UNITED

      if (type) {
        const response = await axios.get(`/support-tables/for-select/${type}`)
        setOptions(response.data || [])
      }
    }

    loadData()
  }, [divisionId])

  return options
}

export default useGetProspectStageByDivision
